import ValueObject from './ValueObject';

export default class GroupLocationId extends ValueObject {
  equals(other) {
    if (!(other instanceof GroupLocationId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new GroupLocationId(json);
  }
}
